var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedErrorGiftCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 78,
    r: 77,
    fill: "#FFEFEA",
    stroke: "#E93024",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 78,
    r: 54,
    fill: "#FFD9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3633_32517)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3633_32517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0002 41.334C70.7482 41.334 63.6591 43.4844 57.6293 47.5134C51.5995 51.5424 46.8998 57.269 44.1246 63.9689C41.3494 70.6689 40.6233 78.0413 42.0381 85.154C43.4528 92.2666 46.945 98.8 52.0729 103.928C57.2009 109.056 63.7342 112.548 70.8469 113.963C77.9595 115.378 85.332 114.651 92.0319 111.876C98.7319 109.101 104.458 104.401 108.487 98.3716C112.516 92.3418 114.667 85.2526 114.667 78.0007C114.667 68.276 110.804 58.9497 103.927 52.0734C97.0511 45.1971 87.7248 41.334 78.0002 41.334ZM73.4474 59.6673C73.4474 58.4517 73.9303 57.286 74.7898 56.4264C75.6494 55.5669 76.8152 55.084 78.0307 55.084C79.2463 55.084 80.4121 55.5669 81.2716 56.4264C82.1312 57.286 82.6141 58.4517 82.6141 59.6673V80.7201C82.6141 81.322 82.4955 81.918 82.2652 82.4741C82.0348 83.0301 81.6972 83.5354 81.2716 83.961C80.846 84.3866 80.3408 84.7242 79.7847 84.9545C79.2286 85.1849 78.6326 85.3034 78.0307 85.3034C77.4288 85.3034 76.8328 85.1849 76.2768 84.9545C75.7207 84.7242 75.2154 84.3866 74.7898 83.961C74.3642 83.5354 74.0266 83.0301 73.7963 82.4741C73.566 81.918 73.4474 81.322 73.4474 80.7201V59.6673ZM78.0002 100.917C76.9607 100.917 75.9446 100.609 75.0803 100.032C74.2161 99.4541 73.5425 98.6333 73.1447 97.673C72.7469 96.7127 72.6428 95.6559 72.8456 94.6365C73.0484 93.617 73.5489 92.6805 74.2839 91.9455C75.0189 91.2105 75.9554 90.71 76.9749 90.5072C77.9943 90.3044 79.0511 90.4085 80.0114 90.8063C80.9717 91.204 81.7925 91.8777 82.37 92.7419C82.9475 93.6062 83.2557 94.6223 83.2557 95.6618C83.2557 97.0556 82.702 98.3924 81.7164 99.378C80.7308 100.364 79.394 100.917 78.0002 100.917Z",
    fill: "#FD3030"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3633_32517",
    x: 37.3335,
    y: 41.334,
    width: 81.3333,
    height: 81.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.188235 0 0 0 0 0.188235 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3633_32517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3633_32517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3633_32517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white",
    transform: "translate(23 23)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedErrorGiftCard);
export default __webpack_public_path__ + "static/media/red-error-gift-card.f615491da582adebfb01949f3c9b668d.svg";
export { ForwardRef as ReactComponent };